var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('dns-resolver-list',{attrs:{"campusSlug":_vm.campusSlug,"canChangeCampus":_vm.canChangeCampus,"fixedNetworkCampus":_vm.fixedNetworkCampus}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }